import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ov_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/address/")) {
      localStorage.removeItem("ov_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n || 0);

export function customerAddressBook(c) {
  if (Array.isArray(c?.addresses) && c.addresses.length) return c.addresses;
  const a = c?.address;
  if (a && (a.line1 || a.pincode)) {
    return [{ id: "legacy", label: "Home", is_default: true, ...a }];
  }
  return [];
}

export function formatAddressLine(a) {
  if (!a) return "";
  return [a.line1, a.line2, a.landmark, [a.city, a.state, a.pincode].filter(Boolean).join(", ")]
    .filter(Boolean)
    .join(" · ");
}

/** Resolve stored image paths (/api/uploads/...) against the API host when needed. */
export function mediaUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || path.startsWith("data:")) return path;
  const base = (BACKEND_URL || "").replace(/\/$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

export default api;
